var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4access") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MySymbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(-3.000000, -1.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Atoms-/-Icons-/-House-/-01.-Outline"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9211426,13.0092773 C10.8211426,13.0092773 9.92114258,13.9092773 9.92114258,15.0092773 C9.92114258,16.1092773 10.8211426,17.0092773 11.9211426,17.0092773 C13.0211426,17.0092773 13.9211426,16.1092773 13.9211426,15.0092773 C13.9211426,13.9092773 13.0211426,13.0092773 11.9211426,13.0092773 Z M17.9211426,8.00927734 L16.9211426,8.00927734 L16.9211426,6.00927734 C16.9211426,3.24927734 14.6811426,1.00927734 11.9211426,1.00927734 C9.64114258,1.00927734 7.65114258,2.54927734 7.08114258,4.75927734 C6.94114258,5.29927734 7.16,5.74 7.7,5.88 C8.23,6.02 8.66,5.6 8.8,5.06 C9.14,3.74 10.5511426,2.6 11.9211426,2.6 C13.5711426,2.6 15.3,4.35927734 15.3,6.00927734 L15.3,8.00927734 L5.92114258,8.00927734 C4.82114258,8.00927734 3.92114258,8.90927734 3.92114258,10.0092773 L3.92114258,20.0092773 C3.92114258,21.1092773 4.82114258,22.0092773 5.92114258,22.0092773 L17.9211426,22.0092773 C19.0211426,22.0092773 19.9211426,21.1092773 19.9211426,20.0092773 L19.9211426,10.0092773 C19.9211426,8.90927734 19.0211426,8.00927734 17.9211426,8.00927734 Z M18.5211426,19.41 C18.5211426,20.015 18.0261426,20.51 17.4211426,20.51 L6.42114258,20.51 C5.81614258,20.51 5.32114258,20.015 5.32114258,19.41 L5.32114258,10.61 C5.32114258,10.005 5.81614258,9.51 6.42114258,9.51 L17.4211426,9.51 C18.0261426,9.51 18.5211426,10.005 18.5211426,10.61 L18.5211426,19.41 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccess);
export default __webpack_public_path__ + "static/media/access.20228f3c1bdcb24e7007a78695a3d76f.svg";
export { ForwardRef as ReactComponent };